
import React from 'react';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';


function Mail() {
	const [mail, setMail] = React.useState("");

	const handleMail = (e) => {
		const n = e.target.value
		setMail(n);
	};

	return (
		<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">
			<Grid item xs={4} md={6}>
				<Typography variant='subtitle1' sx={{ marginTop: "20px", textAlign: "center", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff" }}>
					La tua email
				</Typography>
			</Grid>
			<Grid item xs={8} md={6}>
				<TextField
					id="email"
					label="Email"
					name="email"
					value={mail}
					variant="standard"
					sx={{ m: 1 }}
					required
					onChange={(e) => handleMail(e)}
					inputProps={{ maxLength: 99, style: {fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}} 
          			InputLabelProps={{style: {fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color: "#fff"}}}  
				/>
			</Grid>
		</Grid>
	)
}

export default Mail;